import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import './TimeoutModal.css';

const TimeoutModal = () => {
  const {
    showTimeoutWarning,
    setShowTimeoutWarning, 
    timeoutCounter,
    extendSession,
    logout,
    isAuthenticated,
    sessionExpired,
    setSessionExpired 
  } = useAuth();
  
  const navigate = useNavigate();
  const location = useLocation();

  // Close modal immediately when not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      setShowTimeoutWarning(false);
    }
  }, [isAuthenticated, setShowTimeoutWarning]);

  // Check for session expired flag in URL or context
  const isSessionExpired = sessionExpired || location.search.includes('session=expired');

  const handleReturnToLogin = async () => {
    // First hide the modal
    setShowTimeoutWarning(false);
    setSessionExpired(false);
    
    // Then perform logout and navigation
    try {
      await logout();  // Ensure this properly clears auth state
      navigate('/login?session=expired', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login?session=expired', { replace: true });
    }
  };
  
  const shouldShowModal = (isAuthenticated && showTimeoutWarning) || sessionExpired;

  if (!shouldShowModal) return null;
  

  if (!isAuthenticated && isSessionExpired) {
    return (
      <div className="timeout-modal-overlay">
        <div className="timeout-modal session-expired">
          <h2>Session Expired</h2>
          <p>Your session has expired. Please sign in again.</p>
          <div className="timeout-modal-actions">
            <button 
              className="timeout-modal-logout"
              onClick={handleReturnToLogin}
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!showTimeoutWarning || !isAuthenticated) return null;

  const isExpired = timeoutCounter <= 0;

  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    }
  };

  return (
    <div className="timeout-modal-overlay">
      <div className={`timeout-modal ${isExpired ? 'session-expired' : ''}`}>
        <h2>{isExpired ? 'Session Expired' : 'Session About to Expire'}</h2>
        <p>
          {!isExpired 
            ? <>Your session will expire in <strong>{timeoutCounter} seconds</strong> due to inactivity. Would you like to continue working?</>
            : 'Your session has expired. Please sign in again.'}
        </p>
        <div className="timeout-modal-actions">
          {!isExpired ? (
            <>
              <button 
                className="timeout-modal-extend"
                onClick={extendSession}
              >
                Continue Session
              </button>
              <button 
                className="timeout-modal-logout"
                onClick={handleSignOut}
              >
                Sign Out Now
              </button>
            </>
          ) : (
            <button 
              className="timeout-modal-logout"
              onClick={handleReturnToLogin}
            >
              Return to Login
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimeoutModal;